import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface EditNameFormProps {
  initialName: string;
  onSubmit: (name: string) => void;
  onCancel: () => void;
}

export function EditNameForm({ initialName, onSubmit, onCancel }: EditNameFormProps) {
  const [name, setName] = useState(initialName);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit(name);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name">الاسم</Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="أدخل الاسم"
          autoFocus
        />
      </div>
      <div className="flex gap-2">
        <Button type="submit" disabled={!name.trim()} className="flex-1">
          حفظ
        </Button>
        <Button type="button" variant="outline" onClick={onCancel} className="flex-1">
          إلغاء
        </Button>
      </div>
    </form>
  );
}